
































































































































































































































import { Mixins, Component } from "vue-property-decorator";
import { BvModalEvent, BvMsgBoxOptions } from "bootstrap-vue";
import {
	auth,
	busy,
	createEventInfo,
	db,
	getVipCapabilityRequestStatusLabel,
	toaster,
	VIPCapability,
	VIPCapabilityCertificate,
	VIPCapabilityCertificateRest,
	VIPCapabilityRequestRest,
	VipCapabilityRequestStatus,
	VIPCapabilityRest,
	VipCapabilityStatus,
	VipCapabilityType,
	VIPCertificate,
	VIPCertificateRest,
	VipCertificateStatus,
	VipEventType,
	VIPIp,
} from "@/loader";
import { VIPCapabilityRequestEditViewMixin } from "@/mixins/VIPCapabilityRequestMixin";
import { vip } from '../store/VIPModule';
import CapabilityStatusBadge from "../component/capability/CapabilityStatusBadge.vue";
import CertificatePdfModal from "../component/certificate/CertificatePdfModal.vue";
import CertificatesList from "../component/certificate/CertificatesList.vue";
import EventsSidebar from "../component/event/EventsSidebar.vue";
import IpRule from "../component/ip/IpRule.vue";
import IpTree from "../component/ip/IpTree.vue";
import dayjs from "dayjs";


@Component({
	components: {
		CapabilityStatusBadge,
		CertificatePdfModal,
		CertificatesList,
		EventsSidebar,
		IpRule,
		IpTree,
	},
})
export default class CapabilityRequestView extends Mixins(VIPCapabilityRequestEditViewMixin({
	redirection: { name: "Capabilities" },
	loadMessage: "Chargement de la demande de capacité ...",
	getParams: {
		options: {
			capabilities: {
				ip: true,
				certificates: {
					certificate: {
						project: true,
						ips: true,
					},
				},
			},
		},
	},
})) {
	public certificate: VIPCertificate | null = null;
	public status: VipCapabilityRequestStatus | null = null;
	public statuses = VipCapabilityRequestStatus;
	public accepted: Number[] = [];
	public change_types: Number[] = [];
	public accept_date: Date | null = null;
	public activeCapability: VIPCapability | null = null;
	public tabIndex: number = 0;
	public date: Date | null = null;

	public get compareDate() {
		return !this.item || this.item.isStatusDraft || !this.item.date ? dayjs() : this.item.date;
	}

	public get token() {
		return auth.token;
	}

	public get capabilities() {
		return db.capabilities.list.filter(c => this.item && c.fk_capability_request == this.item.id);
	}

	public get certificates_ids() {
		return this.capabilities.map(cc => cc.certificates).flat().map(cc => cc.fk_certificate) || [];
	}

	public get ips(): VIPIp[] {
		return <VIPIp[]>this.capabilities.filter(cc => !!cc.ip).map(cc => cc.ip) || [];
	}

	public get canClose() {
		return this.item?.isStatusSent || false
	}

	public get canEdit() {
		return this.item?.isStatusDraft || false
	}

	public get canSend() {
		return this.item?.isStatusDraft || false
	}

	public get possible_capabilities(): VIPCapability[] {
		return db.capabilities.list.filter(c => c.id < 0);
	}

	public get possible_ips(): VIPIp[] {
		return <VIPIp[]>this.possible_capabilities.map(c => c.ip).filter(x => !!x);
	}

	public get capability() {
		return (ip: VIPIp) => this.capabilities.find(c => c.ip === ip) || null;
	}

	public get certificates() {
		return (ip: VIPIp) => this.capability(ip)?.certificates.map(cc => cc.certificate) || null;
	}

	public get possible_certificates() {
		return (capability: VIPCapability) => {
			if (capability.ip) {
				const selected_certificates = capability.certificates.map(cc => cc.fk_certificate);
				return db.certificates.list.filter(c => c.isSigned && c.hasIP(capability.fk_ip) && !selected_certificates.includes(c.id));
			}
			return [];
		};
	}

	public get possible_capability() {
		return (ip: VIPIp) => this.possible_capabilities.find(c => c.ip === ip) || null;
	}

	public get statusLabel(): string {
		return getVipCapabilityRequestStatusLabel(this.status || this.item?.status || VipCapabilityRequestStatus.draft);
	}

	public get canSignCustomary(): boolean {
		if (!auth.user || !this.activeCapability) {
			return false;
		}

		return auth.user.capabilities.edit_vip_capability && this.activeCapability.isSent && this.activeCapability.isTypeCustomary || false;
	}

	public get canSignProbationary(): boolean {
		if (!auth.user || !this.activeCapability) {
			return false;
		}

		return auth.user.capabilities.edit_vip_capability && this.activeCapability.isSent || false;
	}

	public get canExtend(): boolean {
		if (!auth.user || !this.activeCapability) {
			return false;
		}

		return auth.user.capabilities.edit_vip_capability && this.activeCapability.isSigned && this.activeCapability.canExtend && !this.activeCapability.extension || false;
	}

	public createCapability() {
		if (this.canEdit && this.item) {
			vip.createCapability({ fk_capability_request: this.item.id });
		}
	}

	public addCapabilityByIp(ip: VIPIp | null) {
		if (this.canEdit && this.item && ip) {
			var capability = this.possible_capability(ip);
			if (capability) {
				capability.fk_capability_request = this.item.id;
				vip.showCapability(capability);
			}
		}
	}

	public viewCapabilityByIp(ip: VIPIp | null) {
		if (ip) {
			let capability = this.capability(ip);
			if (capability) {
				// @ts-ignore
				this.$router.push({ name: "Capability", params: { id: capability.id } });
			}
		}
	}

	public addCapability(capability: VIPCapability | null) {
		if (this.canEdit && this.item && capability) {
			capability.fk_capability_request = this.item.id;
			vip.showCapability(capability);
		}
	}

	public addCertificate(capability: VIPCapability, certificate: VIPCertificate) {
		if (this.canEdit && capability && certificate) {
			busy.start("Ajout du certificat ...");
			VIPCapabilityCertificateRest.create({
				fk_capability: capability.id,
				fk_certificate: certificate.id,
			}).then(result => {
				if (result.success) {
					this.$emit("saved", result.item);
					this.$root.$emit("vip-capability-certificate-saved", result.item);
				}
			}).finally(() => busy.stop());
		}
	}

	public removeCertificate(capability: VIPCapability | null, certificate: VIPCertificate | VIPCapabilityCertificate | null) {
		if (this.canEdit && this.item && capability && certificate) {
			var cc = certificate instanceof VIPCapabilityCertificate ? certificate : capability.certificates.find(cc => cc.certificate === certificate);
			if (cc) {
				busy.start("Suppression du certificat ...")
				VIPCapabilityCertificateRest.delete(cc, { force: true }).finally(() => busy.stop());
			}
		}
	}

	public viewCertificate(certificate: VIPCertificate) {
		this.certificate = certificate;
		this.$bvModal.show("cap_request_cert_modal");
	}

	public changeStatus(status: VipCapabilityRequestStatus) {
		if (this.item) {
			this.status = status;
			this.item.event = createEventInfo(VipEventType.sent);
			this.$bvModal.show("status_modal");
		}
	}

	public confirmChangeStatus(event: BvModalEvent) {
		if (this.status === VipCapabilityRequestStatus.answered && !this.accept_date) {
			this.$bvModal.show("status_modal");
			toaster.toast({ message: "Veuillez indiquer la date d'acceptation", variant: "warning" });
			return;
		}

		if (this.item && this.status) {
			this.item.status = this.status;
			busy.start("Validation de la demande de capacité ...");
			VIPCapabilityRequestRest.changeStatus(this.item).then(result => {
				if (result.success) {
					this.$emit("saved", this.item);
					this.$root.$emit("vip-capability-request-saved", this.item);
					if (this.item?.status === VipCapabilityRequestStatus.sent) {
						let promises = [];
						busy.start("Sauvegarde des capacités ...");
						for (const capability of this.item.capabilities) {
							capability.status = VipCapabilityStatus.sent;
							capability.event = createEventInfo(VipEventType.sent);
							promises.push(VIPCapabilityRest.changeStatus(capability));
						}
						return Promise.all(promises);
					} else if (this.item?.status === VipCapabilityRequestStatus.answered) {
						let promises = [];
						busy.start("Sauvegarde des capacités ...");
						for (const capability of this.item.capabilities) {
							let is_ok = this.accepted.includes(capability.id);
							let change_type = this.change_types.includes(capability.id);
							if (change_type) {
								capability.type = capability.isTypeCustomary ? VipCapabilityType.customary : VipCapabilityType.probationary;
							}
							capability.status = is_ok ? VipCapabilityStatus.signed : VipCapabilityStatus.refused;
							capability.event = createEventInfo(is_ok ? VipEventType.signed : VipEventType.refused);
							// @ts-ignore "date may be null" => date is already checked before
							capability.date = dayjs(this.accept_date);
							promises.push(VIPCapabilityRest.update(capability));
						}
						return Promise.all(promises);
					}
				}
			}).finally(() => {
				busy.stop();
			});
			this.status = null;
		}
	}

	public async generateDocuments() {
		if (!this.item) {
			return;
		}
		busy.start("Génération de la demande ...");
		try {
			// await VIPCapabilityRequestRest.generateRequestFormPDF(this.item);
			// busy.start("Génération du résumé des IPs ...");
			// await VIPCapabilityRequestRest.generateIpsCertificatesSummaryPDF(this.item);
			await VIPCapabilityRequestRest.generateRequestPDF(this.item);
			window.open(this.item.requestUrl(this.token), "_blank");
		} finally {
			busy.stop();
		}
	}

	public refresh() {
		busy.start("Chargement des capacités ...");
		VIPCapabilityRest.list({
			fk_capability_request: this.item?.id,
			options: {
				ip: true,
				certificates: {
					certificate: {
						project: true
					}
				}
			}
		}).then(() => {
			if (this.item?.isStatusDraft) {
				busy.start("Chargement des capacités disponibles ...");
				return VIPCapabilityRest.getPossibilities();
			}
		}).then(() => {
			if (this.item?.isStatusDraft) {
				busy.start("Chargement des certificats disponibles ...");
				return VIPCertificateRest.list({ status: VipCertificateStatus.signed });
			}
		}).finally(() => busy.stop())
	}

	public mounted() {
		if (!this.possible_capabilities.length && this.item?.isStatusDraft) {
			this.refresh();
		}
	}

	public removeMessageOption(shouldTrash: boolean = false): { message: string } & BvMsgBoxOptions {
		return {
			message: shouldTrash
				? "Êtes-vous sûr de vouloir mettre cette demande de capacité à la corbeille ?"
				: "Êtes-vous sûr de vouloir supprimer cette demande de capacité ?",
			title: shouldTrash ? "Mettre à la corbeille" : "Supprimer",
			cancelTitle: "Non",
			cancelVariant: "outline-secondary",
			okTitle: shouldTrash ? "Mettre à la corbeille" : "Supprimer",
			okVariant: "danger",
			centered: true,
		};
	}

	public removeCapabilityMessageOption(shouldTrash: boolean = false): { message: string } & BvMsgBoxOptions {
		return {
			message: shouldTrash
				? "Êtes-vous sûr de vouloir mettre cette capacité à la corbeille ?"
				: "Êtes-vous sûr de vouloir supprimer cette capacité ?",
			title: shouldTrash ? "Mettre à la corbeille" : "Supprimer",
			cancelTitle: "Non",
			cancelVariant: "outline-secondary",
			okTitle: shouldTrash ? "Mettre à la corbeille" : "Supprimer",
			okVariant: "danger",
			centered: true,
		};
	}

	public removeCapability() {
		if (!this.activeCapability) {
			return;
		} else {
			if (!this.canDelete) {
				return;
			}
			let config = this.removeCapabilityMessageOption(false);
			this.$bvModal.msgBoxConfirm(config.message, config).then((result: boolean | null) => {
				if (result && this.activeCapability) {
					busy.start(`Suppression en cours ...`);
					VIPCapabilityRest.delete(this.activeCapability, { force: true }).then(result => {
						if (result.success) {
							toaster.toast({
								variant: "success",
								message: "L'élément a été supprimée avec succès.",
							});
							this.$emit("removed", this.activeCapability);
							this.$root.$emit("vip-capability-removed", this.activeCapability);
							this.activeCapability = null;
							this.tabIndex = 0;
						}
					}).finally(() => {
						busy.stop();
					});
				}
			});
		}
	}

	public extendCapability() {
		if (!this.activeCapability || !this.canExtend) {
			return;
		}
		busy.start("Extension de la capacité ...");
		this.activeCapability.event = createEventInfo(VipEventType.extended);
		this.activeCapability.extension = true;
		VIPCapabilityRest.update(this.activeCapability).then(result => {
			if (result.success) {
				this.$root.$emit("vip-capability-saved", this.activeCapability);
			}
		}).finally(() => {
			busy.stop();
		});
	}
}
